<template>
  <DModal :showClose="false" :isBgOverlay="true" @close="$emit('close')" :isCloseOnEsc="!activeOpusUser">
    <div class="d-modal d-modal__full-width" slot="insertComponent">
      <div class="d-modal__header">
        <h2>{{ userName }} <span class="d-tag marg-1-left">{{ title }}</span>
        </h2>
        <div class="d-modal__header__right">
          <button class="do-bttn no-print" v-if="isSalaryIntegrationActive" @click="setActiveOpusUser(user)">
            Se i OPUS
          </button>
          <button class="do-bttn no-print"
                  @click="isShowUserTable = !isShowUserTable">
            Vis tabel
          </button>
          <button class="do-bttn no-print" @click="print"><span class="icon-printer3"></span></button>
          <div class="icon__bg-circle no-print" @click="$emit('close')">
            <span class="icon-cross2"></span>
          </div>
        </div>
      </div>
      <div class="d-modal__content" id="printUserSalary">
        <Loader bgColor="#fff" v-if="isLoading"></Loader>
        <h4 class="italic" v-if="!user">
          Ikke flere dage på brugeren i <span class="d-tag">{{ title }}</span>
        </h4>
        <div class="user-list__user" v-if="user && !isLoading">
          <h2 class="only-print marg-1-bottom">{{ user && user.v_user_name ? user.v_user_name : '' }} <span
            class="d-tag marg-1-left">{{ title }}</span></h2>
          <div class="user-list__user__header">
            <h4>Samlet timer for perioden i <span class="d-tag">{{ title }}</span><br>{{ titleOfPeriod }}</h4>
            <ul>
              <li v-for="sum in user.v_user_sums"
                  :key="sum.employment_id"
                  :class="{'user-list__user__footer__sums__sum--not-set': sum.employment_not_set}">
                {{ sum.employment_title }}: <b>{{ sum.minutes_humanized }}</b>
              </li>
            </ul>
          </div>
          <SalarySubsPerfUserTable
            v-if="isShowUserTable"
            @close="isShowUserTable = false"
            :user="user"
            :startDate="startDate"
            :endDate="endDate">
          </SalarySubsPerfUserTable>
          <table class="user-list__user__table user-list__user__table--active">
            <template v-for="userDay in user.days">
              <!-- Head for den enkelte dag -->
              <tr class="user-list__user__table__header">
                <th>{{ userDay.v_date_formatted }}</th>
                <th>Kalender</th>
                <th>Type</th>
                <th>Vikar for</th>
                <th>Ansættelse</th>
                <th v-if="isSalaryIntegrationActive">Lønkode</th>
                <th v-if="isSalaryIntegrationActive">Løbenummer</th>
                <th v-if="isSalaryIntegrationActive && costCenters.length > 0">Cost center</th>
                <th></th>
              </tr>
              <!-- Body for den enkelte dag -->
              <SalarySubsPerfUserDay
                :user="user"
                :userDay="userDay"
                :isSalaryIntegrationActive="isSalaryIntegrationActive"
                :salaryCodes="salaryCodes"
                :loebenummer="loebenummer"
                :costCenters="costCenters"
                @updatePropOnLesson="$emit('updatePropOnLesson', $event)"
              />
              <!-- Footer for den enkelte dag -->
              <tr class="user-list__user__table__footer" :key="'foot-' + userDay.day">
                <td :colspan="!isSalaryIntegrationActive ? 6 : 9">
                  <div class="user-list__user__footer">
                    <ul class="user-list__user__footer__sums">
                      <li v-for="sum in userDay.v_sums"
                          :key="sum.employment_id"
                          :class="{'user-list__user__footer__sums__sum--not-set': sum.employment_not_set}">
                        {{ sum.employment_title }}: <b>{{ sum.minutes_humanized }}</b>
                      </li>
                    </ul>
                    <div class="submit-buttons no-print" v-if="userDay.state === 'approved'">
                      <button class="do-bttn do-bttn--danger no-print"
                              @click="$emit('unApproveDay', userDay)"
                              :content="'Dagen vil blive genberegnet'"
                              v-tippy="{
                        arrow: true,
                        animateFill: false,
                        animation : 'shift-away',
                        zIndex: '999999992',
                        boundary: 'window'
                      }">
                        Fortryd godkendelse
                      </button>
                      <button class="do-bttn do-bttn--submit no-print"
                              @click="$emit('changeStateIsSent', userDay)">
                        {{ isSalaryIntegrationActive ? 'Send til lønsystem' : 'Er indberettet' }}
                      </button>
                    </div>
                    <template v-if="userDay.state === 'draft'">
                      <button class="do-bttn do-bttn--submit do-bttn--submit--disabled no-print"
                              v-if="getIsDayValidated(userDay)"
                              :content="'Du skal vælge ansættelse på hver lektion'"
                              v-tippy="{
                        arrow: true,
                        animateFill: false,
                        animation : 'shift-away',
                        zIndex: '999999992',
                        boundary: 'window'
                      }">
                        Godkend
                      </button>
                      <button class="do-bttn do-bttn--submit no-print"
                              :class="{'do-bttn--submit--loading': getIsSubmitting(userDay)}"
                              @click="$emit('approveDay', userDay)" v-else>
                        Godkend
                      </button>
                    </template>
                  </div>
                </td>
              </tr>
            </template>
          </table>
        </div>
      </div>
      <SalarySubsPerfUserOpusModal
        v-if="activeOpusUser"
        :user="activeOpusUser"
        :startDate="startDate"
        :endDate="endDate"
        :schoolId="schoolId"
        @close="setActiveOpusUser(null)">
      </SalarySubsPerfUserOpusModal>
    </div>
  </DModal>
</template>
<script>
import DModal from '../common/DModal.vue'
import SalarySubsPerfUserDay from './SalarySubsPerfUserDay.vue'
import moment from 'moment'
import SalaryFilters from './SalaryFilters.vue'
import Loader from '../common/Loader.vue'
import SalarySubsPerfUserTable from './SalarySubsPerfUserTable.vue'
import SalarySubsPerfUserOpusModal from './SalarySubsPerfUserOpusModal.vue'

export default {
  components: {
    SalarySubsPerfUserOpusModal,
    SalarySubsPerfUserTable, Loader, SalaryFilters, SalarySubsPerfUserDay, DModal
  },
  props: {
    usersPackedInDaysWithProps: {
      type: Array,
      default: () => []
    },
    activeUserId: {
      default: null
    },
    startDate: {
      default: () => moment().startOf('month')
    },
    endDate: {
      default: () => moment().endOf('month')
    },
    schoolId: {
      default: null
    },
    activeFilter: {
      default: 'draft'
    },
    theUserDaySubmitting: {},
    isSalaryIntegrationActive: {
      type: Boolean,
      default: false
    },
    salaryCodes: {
      type: Array,
      default: () => []
    },
    loebenummer: {
      type: Array,
      default: () => []
    },
    costCenters: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      isLoading: false,
      isShowUserTable: false,
      activeOpusUser: null
    }
  },
  computed: {
    user () {
      return this.usersPackedInDaysWithProps.find(user => user.user_id === this.activeUserId) ? this.usersPackedInDaysWithProps.find(user => user.user_id === this.activeUserId) : null
    },
    userName () {
      return this.user && this.user.v_user_name ? this.user.v_user_name : ''
    },
    titleOfPeriod () {
      return moment(this.startDate).format('LL') + ' - ' + moment(this.endDate).format('LL')
    },
    title () {
      switch (this.activeFilter) {
        case 'draft':
          return 'Efterbehandling'
        case 'approved':
          return 'Godkendt'
        case 'sent':
          return this.isSalaryIntegrationActive ? 'Sendt til lønsystem' : 'Er indberettet'
      }
    }
  },
  methods: {
    setActiveOpusUser (user) {
      this.activeOpusUser = user
    },
    getIsSubmitting (userDay) {
      return this.theUserDaySubmitting === userDay.day_id
    },
    getIsDayValidated (userAndDay) {
      return !userAndDay.events.every(event => event.employment_id)
    },
    print () {
      const fileTitle = 'Vikarløn Efterbehandling ' + this.userName + ' - ' + moment(this.startDate).format('DD-MM-YYYY') + '_' + moment(this.endDate).format('DD-MM-YYYY') + ' • docendo.dk'
      // https://stackoverflow.com/questions/52343006/how-to-print-a-part-of-a-vue-component-without-losing-the-style
      const prtHtml = document.getElementById('printUserSalary').innerHTML
      // Get all stylesheets HTML
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"][href*="/app/static/css/"], style')]) {
        stylesHtml += node.outerHTML
      }
      // Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')

      WinPrint.document.write(`<!DOCTYPE html><html id="html-bg-white"><head><title>${fileTitle}</title>${stylesHtml}</head><body>${prtHtml}</body></html>`)
      var afterPrint = () => {
        WinPrint.close()
      }
      WinPrint.onafterprint = afterPrint
      setTimeout(_ => {
        WinPrint.document.close()
        WinPrint.focus()
        WinPrint.print()
      }, 1000)
    }
  },
  mounted () {
    // HACK TO AVOID CLUNKY OPEN OF MODAL
    this.isLoading = true
    setTimeout(_ => {
      this.isLoading = false
    }, 500)
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.d-modal__full-width {
  top: 0;
  left: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
}

.d-modal .d-modal__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 55px;
  border-radius: 0;
  margin-bottom: 0;
  text-align: left;
}

.d-modal__content {
  min-height: calc(100vh - 55px);
  max-height: calc(100vh - 55px);
  overflow-y: auto;
  background: #fff;
}


.user-list__user {
  margin: 0 0 2rem 0;
}

.user-list__user__header {
  padding: 0.5rem 1rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border: 1px solid #ccc;
  margin-bottom: 1rem;
}

.user-list__user__header div {
  font-size: 16px;
  font-weight: bold;
}

.user-list__user__header ul {
  text-align: right;
  margin: 0;
}

.user-list__user__table {
  width: 100%;
  border-collapse: collapse;
}

.user-list__user__table.user-list__user__table--active {
  border: 1px solid #ccc;
}


.user-list__user__table thead tr {
  cursor: pointer;
  background: #f6f9fc;
  border-top: 1px solid #e2e8f0;
  transition: 0.15s;
}

.user-list__user__table thead tr th {
  color: #6b7280;
  text-transform: uppercase;
  font-size: .85rem;
  text-align: left;
}

.user-list__user__table thead tr th,
.user-list__user__table tbody tr td {
  padding: 0.5rem;
}

.user-list__user__table tbody {
  border-top: 1px solid #e2e8f0;
}

.user-list__user__table__footer {
  background-color: #f3f4f6;
}


.user-list__user__footer {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 1rem;
}

.user-list__user > table:last-child thead tr {
  border-radius: 0 0 4px 4px;
}

.user-list__user > table:last-child thead tr th:first-child {
  border-radius: 0 0 0 4px;
}

.user-list__user > table:last-child thead tr th:last-child {
  border-radius: 0 0 4px 0;
}

.user-list__user__table thead tr th {
  text-align: left;
}

.user-list__user__table__arrow {
  padding-right: 0.5rem;
  text-align: right;
  position: relative;
}

.user-list__user__table__arrow svg {
  position: absolute;
  right: 40px;
  top: 8px;
}

.user-list__user__table__arrow > span {
  margin-right: 1rem;
}

.user-list__user__footer__sums {
  text-align: right;
  margin: 0;
}

.user-list__user__footer__sums__sum--not-set {
  color: var(--danger);
}

.submit-buttons {
  gap: 1rem;
  margin-top: 1rem;
}

.user-list__user__table__header {
  background: #f6f9fc;
  border-top: 1px solid #e2e8f0;
  border-width: 1px 0;
}

.user-list__user__table__header th {
  padding: 0.5rem;
  text-align: left;
}

.d-modal__header__right {
  display: flex;
  align-items: center;
  gap: 1rem;
}

@media print {
  .d-modal__content,
  .user-list__user__table thead tr th,
  .user-list__user__table__event tr td,
  .user-list__user__footer {
    font-size: 10px !important;
    color: black;
  }

  .user-list__user__footer {
    padding: 0;
  }

  .d-modal__header {
    text-align: left;
  }

  .user-list__user__table__header {
    background: #fff !important;
    font-size: 8px;
  }

  .user-list__user__header,
  .user-list__user__footer .user-list__user__footer__sums {
    font-size: 8px;
    line-height: 1.7;
  }
}

.d-tag {
  font-size: .8rem;
  background: #f9fafb;
  padding: 0.25rem 0.4rem;
  color: #4b5563;
  border: 1px solid #ebedee;
  border-radius: 4px;
}

</style>



// WEBPACK FOOTER //
// SalarySubsPerfUser.vue?33225f0e